import React from 'react';
import { Step } from './Step';
import { StepState } from './StepState';
import { FlexWrapper } from './styled';

export interface StepCounterProps {
  activeStep: number;
  stepDescriptions: { text: string; url?: string }[];
  isFailedStep?: (step: string) => boolean | undefined;
}

const calculateStepState = (index: number, activeStep: number) => {
  if (index < activeStep) return StepState.Previous;
  if (index === activeStep) return StepState.Current;
  return StepState.Next;
};

export const StepCounter: React.FC<StepCounterProps> = ({
  activeStep,
  stepDescriptions,
  isFailedStep,
}) => (
  <FlexWrapper>
    {stepDescriptions?.map((step, index) => {
      const stepNumber = index + 1;
      return (
        <Step
          // eslint-disable-next-line react/no-array-index-key
          key={`${step?.text?.replace(' ', '-')}-${index}`}
          state={calculateStepState(stepNumber, activeStep)}
          isFailedStep={isFailedStep?.(stepNumber.toString())}
          text={step?.text}
          firstStep={stepNumber === 1}
          lastStep={stepNumber === stepDescriptions.length}
          stepNumber={stepNumber}
          afterCurrent={activeStep + 1 === stepNumber}
          url={step?.url}
        />
      );
    })}
  </FlexWrapper>
);
